export default function parsePolyStrings(polyString) {
  let tmp;
  const result = [];
  // match '(' and ')' plus contents between them which contain anything other than '(' or ')'
  const match = polyString.match(/\([^()]+\)/g);
  if (match !== null) {
    for (let i = 0; i < match.length; i += 1) {
      // match all numeric strings
      tmp = match[i].match(/-?\d+\.?\d*/g);
      if (tmp !== null) {
        // convert all the coordinate sets in tmp from strings to Numbers
        // and convert to LatLng objects
        const coordinates = [];
        let lat;
        let lng;
        for (let j = 0; j < tmp.length; j += 2) {
          lng = Number(tmp[j]);
          lat = Number(tmp[j + 1]);
          coordinates.push(new google.maps.LatLng(lat, lng));
          // coordinates.push({ lat, lng });
        }
        result.push(coordinates);
      }
    }
  }
  // array of arrays of LatLng objects, or empty array
  return result;
}



// WEBPACK FOOTER //
// ./src/js/logic/parsePolyStrings.js